import { useEffect, useState } from 'react';
import { WARMING_EVENT, WARMING_DONE_EVENT } from '@/core/warmingNotice';
import { t } from '../../i18n/t';

/**
 * Round 136b - shown only when the page's first server answer takes more than 2 s (a server waking up after a quiet spell; see
 * core/warmingNotice.ts). Mounted once at the app root. A small polite status at the top, not a blocker: it disappears as soon as the
 * first answer arrives. role="status" so assistive tech announces it without interrupting.
 */
export default function WarmingNotice() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = () => setVisible(true);
    const hide = () => setVisible(false);
    window.addEventListener(WARMING_EVENT, show);
    window.addEventListener(WARMING_DONE_EVENT, hide);
    return () => { window.removeEventListener(WARMING_EVENT, show); window.removeEventListener(WARMING_DONE_EVENT, hide); };
  }, []);
  if (!visible) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="warming-notice"
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9997,
        background: '#1f2937', color: 'white', padding: '10px 16px', fontSize: '14px', textAlign: 'center',
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
      }}
    >
      <span aria-hidden="true" className="inline-block h-3 w-3 rounded-full border-2 border-white border-t-transparent animate-spin" />
      <span>{t('common:warming.gettingReady')}</span>
    </div>
  );
}
